import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertComponent } from '../../../alert/alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from '../../../loading/loading.service';
import { MunicipalitiesService } from 'src/app/modules/services/municipalities/municipalities.service';
import { SegmentsService } from 'src/app/modules/services/segments/segments.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CadHighwayModalComponent } from '../cad-highway-modal/cad-highway-modal.component';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-new-highway-modal',
  templateUrl: './new-highway-modal.component.html',
  styleUrls: ['./new-highway-modal.component.scss']
})
export class NewHighwayModalComponent implements OnInit {
  cities: any[] = [];
  highways: any[] = [];
  searchControlHighwayHeader = new FormControl(null, [Validators.required]); // Adiciona validação required
  form!: FormGroup;
  descriptionHighwayHeader = new FormControl();
  selectedOptionMunicipios: any;
  filteredOptionsMunicipios: any[] = [];
  searchControlMunicipiosHeader = new FormControl(null); // Adiciona validação required
  selectedOptionHighway: any;
  filteredOptionsHighway: any[] = [];
  @Input() isEditMode: boolean = false;
  searchControl = new FormControl();

  contractId: any;
  searchText: string = '';
  constructor(
    private dialog: MatDialog,
    private highWayService: HighwaysService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private municipioService: MunicipalitiesService,
    @Inject(MAT_DIALOG_DATA) public uploadData: any,
    private segmentService: SegmentsService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<NewHighwayModalComponent>,
    private fb: FormBuilder,
  ) {
    iconRegistry.addSvgIcon(
      'filter-icon',
      sanitizer.bypassSecurityTrustResourceUrl('assets/create-user/svgs/trailing-icon.svg')
    );
  }

  back() {
    this.dialogRef.close()
  }
  ngOnInit(): void {
    this.contractId = this.uploadData.contract_id;
    this.getRodovias();
    // this.searchControlHighwayHeader.valueChanges.pipe(
    //   debounceTime(800),
    //   distinctUntilChanged(),
    //   filter((value: any) => value),
    //   switchMap(value => {
    //     this.searchText = value;
    //     return this.highWayService.getAll(0, '', '', value).pipe(
    //       catchError(() => {
    //         this.searchText = value;
    //         this.filteredOptionsHighway = [{ addNew: true }];
    //         return of([]);
    //       })
    //     )
    //   }
    //   )
    // ).subscribe(
    //   {
    //     next: (results: any) => {
    //       this.filteredOptionsHighway = results.content;

    //       if (this.filteredOptionsHighway?.length === 0 || this.filteredOptionsHighway === undefined) {
    //         this.filteredOptionsHighway = []

    //         this.filteredOptionsHighway.push({ addNew: true });
    //       }
    //       if (results?.content?.length) {
    //         this.filteredOptionsHighway = results.content;
    //       } else {
    //         this.filteredOptionsHighway = [];
    //         this.filteredOptionsHighway = [{ addNew: true }];
    //       }
    //     }, error: (err: any) => {
    //       this.filteredOptionsHighway = [];
    //       this.filteredOptionsHighway = [{ addNew: true }];
    //     }
    //   }
    // );

    this.form = this.fb.group({
        highwayId: ['', Validators.required],
    })
  }

  getRodovias(){
     this.highWayService.getAll(0, '', '', '').subscribe((item:any) =>{
        this.filteredOptionsHighway = item.content;
    })
  }
  onSubmit() {
    const data = {
      highwayId: this.form.value.highwayId,
      description: ''
    }

    this.loadingService.showLoading();
    this.highWayService.addHighway(data, this.contractId).pipe(
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {
        this.openSnackBar('Rodovia adicionada com sucesso.', 'sucess');
        this.selectedOptionHighway = null;
        this.selectedOptionMunicipios = null;
        this.descriptionHighwayHeader.setValue('');

        this.dialogRef.close(res);
      }, error: (err: any) => {
        this.dialogRef.close();
        this.openSnackBar(err.error.message, 'error');
      }
    })
  }
  onFocusHighway() {
    this.filteredOptionsHighway = this.highways;
  }
  onOptionSelectedHighwayHeader(event: any) {
    this.selectedOptionHighway = event.option.value
    this.searchControlHighwayHeader.setValue(this.selectedOptionHighway.name, { emitEvent: false });

    this.filteredOptionsHighway = [];
  }

  openModalAddNewHighway() {
    let data = {
      isEditMode: false,
      searchText: this.searchText
    }
    const dialog = this.dialog.open(CadHighwayModalComponent, {
      panelClass: ['filter-panel'],
      data: data
    })


    let responseModal: any;
    dialog.afterClosed().subscribe({
      next: (res: any) => {
        if (res) {
          responseModal = res;
          this.loadingService.showLoading();
          this.highWayService.createHighway(res).pipe(
            finalize(() => {
              this.loadingService.hideLoading();
            })
          ).subscribe({
            next: (res: any) => {
              const data = {
                id: res.id,
                description: responseModal.description,
                name: responseModal.name
              }
              this.getRodovias();
              this.form.patchValue({
                highwayId:data.id,
              })
              this.selectedOptionHighway = data;
              this.searchControlHighwayHeader.setValue(data.name, { emitEvent: false });
              this.openSnackBar('Rodovia adicionada com sucesso.', 'sucess');

            }, error: (err: any) => {
              this.openSnackBar(err.error.message, 'error');
            }
          })
        }
      }
    })
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }


}
